// logger.ts

const isDevelopment = process.env.NODE_ENV !== 'production';

/**
 * Logs informational messages to the console when not in production.
 * @param message - The message string to log.
 * @param data - Optional data to log alongside the message.
 */
export function logInfo(message: string, data?: unknown): void {
  if (isDevelopment) {
    if (data) {
      console.log(`[INFO] ${message}`, data);
    } else {
      console.log(`[INFO] ${message}`);
    }
  }
}

/**
 * Logs error messages to the console.
 * In production, this function can be extended to report errors to an external service.
 * @param message - The error message string to log.
 * @param error - Optional error object to log.
 */
export function logError(message: string, error?: unknown): void {
  if (error) {
    console.error(`[ERROR] ${message}`, error);
  } else {
    console.error(`[ERROR] ${message}`);
  }
}

/**
 * Logs warning messages to the console.
 * @param message - The warning message string to log.
 * @param data - Optional data to log alongside the message.
 */
export function logWarning(message: string, data?: unknown): void {
  if (data) {
    console.warn(`[WARN] ${message}`, data);
  } else {
    console.warn(`[WARN] ${message}`);
  }
}

/**
 * Logs debug messages to the console when not in production.
 * @param message - The debug message string to log.
 * @param data - Optional data to log alongside the message.
 */
export function logDebug(message: string, data?: unknown): void {
  if (isDevelopment) {
    if (data) {
      console.debug(`[DEBUG] ${message}`, data);
    } else {
      console.debug(`[DEBUG] ${message}`);
    }
  }
}
